import { AgileBatchRecommedationInput } from '@components/agile/types/AgileRecommendationTypes';
import AgileUploadRow from '@components/agile/types/AgileUploadRow';
import { AssortmentEntryAction } from '@graphql/generated/graphql';
import { AgileMacroplanogram } from '@components/agile/types/AgileMacroplanogramTypes';

const INDEFINITE_TIME = '32506855650000';
export const calculateTotalFacingUnitsPerZone = (data: AgileBatchRecommedationInput[]) => {
  const macroplanogramFacingUnits: { [macroplanogramId: string]: number } = {};

  data.forEach((item) => {
    const { macroplanogramId } = item;
    const itemFacingUnits = item
      ? item.addAssortment.reduce(
          (itemTotal, assortment) => itemTotal + parseInt(String(assortment.facingUnits), 10),
          0,
        )
      : 0;
    if (macroplanogramFacingUnits[macroplanogramId]) {
      macroplanogramFacingUnits[macroplanogramId] += itemFacingUnits;
    } else {
      macroplanogramFacingUnits[macroplanogramId] = itemFacingUnits;
    }
  });
  return macroplanogramFacingUnits;
};
const getMacroplanogramEndTime = (
  macroplanogramId: string | undefined,
  listOfMacroplanogram: AgileMacroplanogram[] | undefined,
) => {
  const zoneDetails = listOfMacroplanogram
    ?.filter((macroplanogramDetails) => macroplanogramDetails.entryId === macroplanogramId)
    .find((obj) => obj);
  return zoneDetails ? (zoneDetails.endTime as string) : INDEFINITE_TIME;
};
const getMacroplanogramDraftStatus = (
  macroplanogramId: string | undefined,
  listOfMacroplanogram: AgileMacroplanogram[] | undefined,
) => {
  const zoneDetails = listOfMacroplanogram
    ?.filter((macroplanogramDetails) => macroplanogramDetails.entryId === macroplanogramId)
    .find((obj) => obj);
  return zoneDetails?.isDraft ?? false;
};

export const groupSelectionByMacroplanogramId = (
  data: AgileUploadRow[],
  swapTime: number,
  listOfMacroplanogram: AgileMacroplanogram[] | undefined,
) => {
  const storeId = listOfMacroplanogram?.[0].storeId as string;
  return Object.values(
    data.reduce(
      (acc, obj) => {
        const { macroplanogramId, asin, subcategoryId, facingUnits, existingFohCapacity, action } = obj;
        if (!acc[macroplanogramId!]) {
          // eslint-disable-next-line no-param-reassign
          acc[macroplanogramId!] = {
            storeId,
            swapTime,
            endTime: getMacroplanogramEndTime(macroplanogramId, listOfMacroplanogram),
            macroplanogramId: String(macroplanogramId),
            addAssortment: [],
            includeDraft: getMacroplanogramDraftStatus(macroplanogramId, listOfMacroplanogram),
          };
        }
        let fohCapacity: number;
        if (action?.action === AssortmentEntryAction.Remove) {
          fohCapacity = 0;
        } else if (action?.action === AssortmentEntryAction.Add) {
          fohCapacity = Number(existingFohCapacity) * Number(facingUnits);
        } else {
          fohCapacity = Number(existingFohCapacity);
        }
        acc[macroplanogramId!].addAssortment.push({
          asin,
          subcategoryId: String(subcategoryId),
          facingUnits: action?.action === AssortmentEntryAction.Remove ? 0 : facingUnits,
          fohCapacity,
        });
        return acc;
      },
      {} as { [key: string]: AgileBatchRecommedationInput },
    ),
  );
};
